import cx from 'classnames';
import { intcomma } from 'journalize';
import { Component, h, VNode } from 'preact';

import AnimatedNumber from './AnimatedNumber';
import PartyPill from './PartyPill';
import PctChange from './PctChange';
import PureComponent from './PureComponent';
import VoteBar from './VoteBar';

import winnerClass from '../utils/winner-class';


interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  contestResult: string;
  isIncumbent: boolean;
  isWinner: boolean;
  isMapRow: boolean;
  party: string;
  totalVotesInContest: number;
  votes: number;
}


const formatVotes = (n: number) => intcomma(Math.round(n));
const formatPct = (n: number) => n.toFixed(1);
const pctValue = (votes: number, total: number) =>
  total == null || total <= 0 ? 0 : (votes / total) * 100;

class CandidateRow extends Component<Props> {
  static Header: VNode;
  static countyHeader: VNode;
  static columnCount: number;

  render() {
    const {
      ballotName,
      contestIsCalled,
      contestResult,
      isIncumbent,
      isWinner,
      isViewable,
      candidatesNum,
      candidateColor,
      isMapRow,
      party,
      totalVotesInContest,
      votes,
    } = this.props;

    let divStyle;

    let checkStyle;

    if (candidateColor) {
      divStyle = {
        'background-color': candidateColor,
      };
      checkStyle = {
        color: candidateColor,
      };
    }

    const uncontested = candidatesNum == 1;

    let rowClass = cx('candidate', 'contest__candidate-row', {
      'contest__candidate-row--winner dem--border':
        contestIsCalled && isWinner && party == 'Democrat',
      'contest__candidate-row--winner rep--border':
        contestIsCalled && isWinner && party == 'Republican',
      'contest__candidate-row--winner gre--border':
        contestIsCalled && isWinner && party == 'Green',
      'contest__candidate-row--winner lib--border':
        contestIsCalled && isWinner && party == 'Libertarian',
    });

    const checkClass = cx('check', winnerClass(party, contestResult));

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    const checkmark = '\u2713';

    // const IsAsterisk =
    // context['asterisks'].filter(candidate => candidate.value == ballotName).length > 0
    //     ? true
    //     : false;

    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
          {!candidateColor && <PartyPill party={party} />}
          {candidateColor && <PartyPill party={party} style={divStyle} />}
        </td>
        <th class="candidate__cell candidate__name">
          <span class="candidate__name-line">
            {/* The feed can flag is_winner before the race is called, so only
                style a winner once it is (same as HeadshotCandidateRow) */}
            {contestIsCalled && isWinner &&
              (contestResult == 'winner' || contestResult == 'uncontested') && (
                <span class={checkClass}>{checkmark}</span>
              )}
            {contestIsCalled && isWinner && contestResult == 'runoff' && (
              <span class={checkClass}>{checkmark}</span>
            )}
            {contestIsCalled && isWinner && !isMapRow && contestResult != 'runoff' ? (
              <span class={checkClass}>{ballotName}</span>
            ) : (
              ballotName
            )}
            {/* {IsAsterisk && <span class="asterisk_out">*</span>}{' '} */}
            {isIncumbent && (
              <span class="pill pill--basic" title="Currently holds this seat">
                Incumbent
              </span>
            )}
          </span>
          {!uncontested && (
            <VoteBar
              value={pctValue(votes, totalVotesInContest)}
              party={party}
              color={candidateColor}
            />
          )}
        </th>
        <td class="candidate__cell candidate__votes">{uncontested == false ? (
          isMapRow ? (
            formatVotes(votes)
          ) : (
            <AnimatedNumber value={votes} format={formatVotes} />
          )
        ) : '—'}</td>
        <td class="candidate__cell candidate__pct">
        {uncontested == false ? (
          isMapRow ? (
            formatPct(pctValue(votes, totalVotesInContest))
          ) : (
            <span>
              <PctChange
                value={pctValue(votes, totalVotesInContest)}
                party={party}
                color={candidateColor}
              />
              <AnimatedNumber
                value={pctValue(votes, totalVotesInContest)}
                format={formatPct}
                odometerFormat="(,ddd).d"
              />
            </span>
          )
        ) : '—'}
          <span class="candidate__pct-symbol">%</span>
        </td>
      </tr>
    );
  }
}

CandidateRow.defaultProps = {
  contestIsCalled: false,
  isViewable: true,
};

CandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

CandidateRow.countyHeader = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

CandidateRow.columnCount = 4;

export default CandidateRow;